import { render, staticRenderFns } from "./SongHuo.vue?vue&type=template&id=54d7f5dc&scoped=true&"
import script from "./SongHuo.vue?vue&type=script&lang=js&"
export * from "./SongHuo.vue?vue&type=script&lang=js&"
import style0 from "./SongHuo.vue?vue&type=style&index=0&id=54d7f5dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d7f5dc",
  null
  
)

export default component.exports